/* eslint-disable camelcase */
/* eslint-disable dot-notation */
import axios, { AxiosResponse } from 'axios';
import type { LoginResponseProps } from '@/hooks/authorization/useToken/useToken';

type LoginRequestType = {
  email: string;
  password: string;
};

type ApiServiceProps = {
  login: (
    params: LoginRequestType,
  ) => Promise<AxiosResponse<LoginResponseProps>>;
};

export default function AuthenticationService(): ApiServiceProps {
  const api = axios.create({
    baseURL: process.env['REACT_APP_BETRYBE_API_URL'],
    headers: {
      'Content-Type': 'application/json',
    },
  });

  async function login(params: LoginRequestType) {
    return api.post<LoginResponseProps>(`/api/accounts/login`, params);
  }

  return { login };
}
